import BlowfishService from '@/utils/blowfish'

let key = process.env.VUE_APP_BLOWFISH_KEY

const encode = function (value) {
	return BlowfishService.encode(value, key)
}

const decode = function (value) {
	return BlowfishService.decode(value, key)
}

export default {
	encode,
	decode
}
